import { USER_ROLES } from "@nlc/shared-types";
import { SparklesIcon } from "lucide-react";

import type { UserRole } from "@/features/auth/permissions/config";

import { Badge } from "@/components/badge";
import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";

import { toIsoDate } from "./aiCostsSearch";
import { formatMicroUsd } from "./formatUsd";
import { useAccountMonthlyAiCost } from "./hooks/useAccountMonthlyAiCost";

const SUPER_ADMIN_ONLY = [USER_ROLES.SUPER_ADMIN] as UserRole[];

export function AccountAiCostBadge({ accountId }: { accountId: number }) {
  const { hasRole } = useRoleAccess();
  const isSuperAdmin = hasRole(SUPER_ADMIN_ONLY);
  const month = toIsoDate(new Date()).slice(0, 7);
  const { data } = useAccountMonthlyAiCost(accountId, month, isSuperAdmin);

  if (!isSuperAdmin || !data) return null;

  return (
    <Badge className="mr-1" isRounded variant="purple">
      <SparklesIcon className="mr-1" size={14} />
      AI this month: {formatMicroUsd(data.totals.costMicroUsd)}
    </Badge>
  );
}
